import React, { FC } from 'react';
import { Column, Columns, Container } from '../../components/base/grid';
import { H1 } from '../../components/base/typography';
import Breadcrumbs from '../../components/breadcrumbs';
import CtaIconBox from '../../components/ctaBoxes/ctaIconBox';
import ShipmentCalculatorForm from '../../components/shipmentCalculatorForm';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';
import * as StyledShipmentCalculator from './shipmentCalculator.styles';

interface Props {
	page: IPageViewModel;
}

const ShipmentCalculator: FC<Props> = ({ page }) => {
	return (
		<Container>
			<Breadcrumbs pageId={page.Id} />
			<H1 marginTop="4rem" marginBottom="4rem">
				{page.Name}
			</H1>
			<Columns>
				<Column desktopSmall={2 / 3}>
					<ShipmentCalculatorForm />
				</Column>
				<StyledShipmentCalculator.StyledColumn desktopSmall={1 / 3}>
					{page.Values.CtaBoxes &&
						page.Values.CtaBoxes.map((contentItem, index) => {
							return (
								<StyledShipmentCalculator.CtaWrapper key={index}>
									<CtaIconBox box={contentItem} />
								</StyledShipmentCalculator.CtaWrapper>
							);
						})}
				</StyledShipmentCalculator.StyledColumn>
			</Columns>
		</Container>
	);
};

export default pageWrapper(ShipmentCalculator);
